export const AR_MONTHS = [
  "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
  "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر",
];

export const today = () => new Date().toISOString().slice(0, 10);

export const comma = (n) => (n ?? 0).toLocaleString("en-US");

export const pct = (v) => `${((v || 0) * 100).toFixed(1)}%`;

export const formatDate = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  return `${parseInt(day)} ${AR_MONTHS[parseInt(m) - 1]} ${y}`;
};

export const formatMonth = (m) => {
  if (!m) return "";
  const [y, mo] = m.split("-");
  return `${AR_MONTHS[parseInt(mo) - 1]} ${y}`;
};

// Both a camera-count surplus (duplicate photos, etc.) and a shortfall
// (missed shots, no internet, ...) are errors, so accuracy penalizes the
// absolute gap between camera and operational replies in either direction
// — it doesn't just cap at 100% when camera > operational.
export const calcAccuracy = (cam, op) =>
  op > 0 ? Math.max(0, 1 - Math.abs(cam - op) / op) : null;

export const accuracyColor = (r) => {
  if (r === null) return "#64748b";
  if (r >= 0.98) return "#22c55e";
  if (r >= 0.95) return "#f59e0b";
  if (r >= 0.90) return "#f97316";
  return "#ef4444";
};

export const accuracyLabel = (r) => {
  if (r === null) return "لا بيانات";
  if (r >= 0.98) return "ممتاز";
  if (r >= 0.95) return "جيد";
  if (r >= 0.90) return "مقبول";
  return "ضعيف";
};

// A raw signed number (+3 / -3) invites reading "+" as good and "-" as bad,
// when in fact BOTH a camera shortfall and a camera surplus are errors —
// that's the whole point of the symmetric accuracy formula above. So every
// screen that shows a per-row diff should show the plain magnitude (never
// negative) plus this descriptive label of which side is off, instead of a
// sign. `diff` = operational_replies - camera_replies.
export const diffInfo = (diff) => {
  const d = diff || 0;
  if (d === 0) return { magnitude: 0, label: "متطابق", color: "#22c55e" };
  if (d > 0) return { magnitude: d, label: "نقص كاميرا", color: "#f59e0b" };
  return { magnitude: -d, label: "زيادة كاميرا", color: "#ef4444" };
};

export const sendTimeConfig = {
  before: { label: "قبل ✅", color: "#22c55e" },
  after: { label: "بعد ⚠️", color: "#f59e0b" },
  not_sent: { label: "لم يُرسل ❌", color: "#ef4444" },
};

export const roleConfig = {
  admin: { label: "👑 مدير", color: "#ef4444" },
  supervisor: { label: "🔧 مشرف", color: "#f59e0b" },
  reviewer: { label: "👤 مراجع", color: "#22c55e" },
  viewer: { label: "📄 عرض التقارير", color: "#38bdf8" },
};

export const diffReasonOptions = [
  "خطأ مراجع", "نت بطئ", "عطل فني كاميرات",
  "انقطاع كهرباء", "منطقة غير مغطاة", "كاميرات مفصولة",
  "يوجد تعبئه سيارات من الخارج", "يوجد تكرار صور", "لا يوجد نت بالموقع",
  "ردود مجانية خاصة بشركة المياه الوطنية",
  "أخرى",
];
